import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import "../styles/SavedRecipes.css";
import SavedAIRecipeCard from "./SavedAIRecipeCard";

interface SavedRecipe {
  id: string;
  title: string;
  instructions: string;
  image_url: string;
}

const SavedRecipes: React.FC = () => {
  const [recipes, setRecipes] = useState<SavedRecipe[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    const fetchRecipes = async () => {
      const { data: sessionData } = await supabase.auth.getSession();
      const user = sessionData.session?.user;

      if (!user) {
        setIsLoggedIn(false);
        setIsLoading(false);
        return;
      }

      setIsLoggedIn(true);

      const { data, error } = await supabase
        .from("saved_recipes")
        .select("*")
        .eq("user_id", user.id)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Virhe haettaessa reseptejä:", error.message);
      } else {
        setRecipes(data || []);
      }

      setIsLoading(false);
    };

    fetchRecipes();
  }, []);

  const handleDelete = async (id: string, title: string) => {
    const { error } = await supabase
      .from("saved_recipes")
      .delete()
      .eq("id", id);
    if (error) {
      alert("Virhe reseptin poistamisessa.");
      console.error("Poistovirhe:", error.message);
    } else {
      setRecipes((prev) => prev.filter((r) => r.id !== id));
      setShowNotification(true);
      setTimeout(() => setShowNotification(false), 3000);
    }
  };

  if (isLoading) return <div>Ladataan reseptejä...</div>;

  if (!isLoggedIn) {
    return (
      <div className="saved-recipes-wrapper">
        <p>Kirjaudu sisään nähdäksesi tallentamasi reseptit.</p>
      </div>
    );
  }

  return (
    <div className="saved-recipes-wrapper">
      <h2 className="saved-recipes-title">Tallennetut AI-reseptit</h2>

      {showNotification && (
        <div className="notification">Resepti poistettu.</div>
      )}

      {recipes.length === 0 ? (
        <div className="empty-recipes">
          {/* 🧹 Tyhjän tilan kuva poistettu kokonaan */}
        </div>
      ) : (
        <div className="saved-recipe-list">
          {recipes.map((recipe) => (
            <div className="recipe-list-item" key={recipe.id}>
              <SavedAIRecipeCard
                recipe={recipe}
                onDelete={() => handleDelete(recipe.id, recipe.title)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedRecipes;
